<template>
  <v-container fluid grid-list-md>
    <v-card class="pa-2 mb-2">
      <v-tooltip :disabled="canCreate" bottom>
        <v-btn
          slot="activator"
          :disabled="!canCreate"
          @click="openEditCategoryDialog(null)"
          color="primary">
          {{ $vuetify.t('$vuetify.AdminCategories.titleAdd') }}
        </v-btn>
        <span>{{ $vuetify.t('$vuetify.Permissions.noPermission') }}</span>
      </v-tooltip>
    </v-card>
    <v-card class="pa-3 mb-2">
      <v-list v-if="categories != null" two-line>
        <v-list-tile
          v-for="category in categories"
          :key="category.id"
          @click>

          <v-list-tile-avatar>
            <v-img :src="category.image"/>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>
              {{ category.name }}
            </v-list-tile-title>
            <v-list-tile-sub-title v-if="category.description.length > 0">
              {{ category.description }}
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <div>
              <v-btn class="pr-4" icon ripple @click.stop="openEditCategoryDialog(category)">
                <v-icon color="grey" v-if="canEdit">edit</v-icon>
              </v-btn>
              <v-btn icon ripple @click.stop="openDeleteCategoryDialog(category)">
                <v-icon color="grey" v-if="canDelete">delete</v-icon>
              </v-btn>
            </div>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card>

    <CategoryEditDialog
      v-if="showEditDialog"
      :show="showEditDialog"
      :category="selectedCategory"
      @handleClose="showEditDialog = false"
      @handleSuccess="closeEditDialog(true)"
      @handleError="closeEditDialog(false)"/>

    <CategoryDeleteDialog
      v-if="showDeleteDialog"
      :show="showDeleteDialog"
      :category="toDelete"
      @handleClose="showDeleteDialog = false"
      @handleSuccess="closeDeleteDialog(true)"
      @handleError="closeDeleteDialog(false)"/>

    <v-snackbar
      v-model="showSnackbar"
      :bottom="true">
      {{ snackbarMsg }}
      <v-btn
        color="accent"
        flat
        @click="showSnackbar = false">
        {{ $vuetify.t('$vuetify.Snackbar.close') }}
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import api from '@/api'
import CategoryEditDialog from '@/components/dialogs/CategoryEditDialog'
import CategoryDeleteDialog from './dialogs/CategoryDeleteDialog'

// PostgREST retuns binary columns in hex encoded format
// this function can be used to return them back to an ascii representation
function hex2a (hexx) {
  var hex = hexx.toString() // force conversion
  var str = ''
  for (var i = 0; (i < hex.length && hex.substr(i, 2) !== '00'); i += 2) {
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
  }
  return str
}

export default {
  name: 'Categories',
  components: {
    CategoryDeleteDialog,
    CategoryEditDialog
  },
  data: function () {
    return {
      categories: null,
      selectedCategory: null,
      toDelete: null,
      showSnackbar: false,
      snackbarMsg: '',
      showEditDialog: false,
      showDeleteDialog: false
    }
  },

  computed: {
    canCreate: function () {
      return this.$hasPermission(this.$permissions.category.items.createCategory)
    },
    canEdit: function () {
      return this.$hasPermission(this.$permissions.category.items.editCategory)
    },
    canDelete: function () {
      return this.$hasPermission(this.$permissions.category.items.deleteCategory)
    }
  },

  beforeMount: function () {
    this.getCategories()
  },

  methods: {
    openEditCategoryDialog (selectedCategory) {
      this.selectedCategory = selectedCategory
      this.showEditDialog = true
    },
    openDeleteCategoryDialog (toDelete) {
      this.toDelete = toDelete
      this.showDeleteDialog = true
    },
    closeEditDialog (successful) {
      if (successful) {
        this.showSnackbar = true
        this.snackbarMsg = this.$vuetify.t('$vuetify.AdminCategories.snackbarSaved')
      } else {
        this.showSnackbar = true
        this.snackbarMsg = this.$vuetify.t('$vuetify.Snackbar.serverError')
      }
      this.showEditDialog = false
      this.selectedCategory = null
      this.getCategories()
    },
    closeDeleteDialog (successful) {
      if (successful) {
        this.showSnackbar = true
        this.snackbarMsg = this.$vuetify.t('$vuetify.AdminCategories.snackbarDeleted')
      } else {
        this.showSnackbar = true
        this.snackbarMsg = this.$vuetify.t('$vuetify.AdminCategories.snackbarDeleteFailed')
      }
      this.showDeleteDialog = false
      this.toDelete = null
      this.getCategories()
    },
    getCategories () {
      const schoolId = this.$store.getters.selected_school
      api.category.get(schoolId).then((res) => {
        const categories = res.data
        // Decode icon file from hex
        for (let i = 0; i < res.data.length; i++) {
          if (categories[i].icon != null) {
            categories[i].icon = hex2a(categories[i].icon)
          }
        }
        this.categories = categories
      })
    },
    deleteCategory () {
      api.category.remove(this.categories[this.toDelete].id)
        .then(res => {
          if (res.status < 400) {
            this.reset()
            this.showSnackbar = true
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminCategories.snackbarDeleted')
          } else {
            this.reset()
            this.showSnackbar = true
            this.snackbarMsg = this.$vuetify.t(
              '$vuetify.AdminCategories.snackbarDeleteFailed')
          }
        })
    }
  }
}
</script>
